import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { AssignmentIcon, IconFillColor, IconSize, IconWrapper } from '@dreryk/react-components';

import { notesTranslationKeys } from '../../translations';
import { NoteFormBean, NoteModalCommon } from '../NoteModalCommon/NoteModalCommon';
import { usePatientNoteQuery } from '../patientNoteHooks';

import { usePatientNoteCreateCommand } from './AddNoteModal.hooks';
import { StyledOpenAddModalLink } from './StyledOpenAddModalLink';

type AddNoteModalProps = {
   readonly patientId: PatientSimple['id'];
};

export const AddNoteModal = (props: AddNoteModalProps): JSX.Element => {
   const [modalOpened, toggleModalOpened] = useToggle(false);
   const { refetch: refetchNotes } = usePatientNoteQuery(props.patientId);

   const onSuccess = (): void => {
      toggleModalOpened();
      refetchNotes();
   };

   const { executeAsync: createPatientNote } = usePatientNoteCreateCommand(onSuccess);

   const onSubmit = useCallback(
      (data: NoteFormBean) => {
         createPatientNote({ ...data, patientId: props.patientId });
      },
      [createPatientNote, props.patientId]
   );

   return (
      <>
         <StyledOpenAddModalLink
            testId={'addNote'}
            label={notesTranslationKeys.modal.addNote}
            onClick={toggleModalOpened}
            icon={
               <IconWrapper size={IconSize.SMALL} fillColor={IconFillColor.INHERIT} testId={'addNote'}>
                  <AssignmentIcon />
               </IconWrapper>
            }
         />

         {modalOpened ? (
            <NoteModalCommon
               toggleModalOpened={toggleModalOpened}
               onSubmit={onSubmit}
               content={''}
               title={notesTranslationKeys.modal.addNoteTitle}
               confirmationButtonLabel={notesTranslationKeys.modal.addNote}
               exitConfirmationMessage={notesTranslationKeys.modal.cancelAdd}
               testId={'addNoteModal'}
            />
         ) : null}
      </>
   );
};
